import { useState, useEffect } from 'react';
import { VideoQuality } from '../types/video.types';
import { NavigatorWithConnection } from '../interfaces/navigator.interface';
import { NetworkEffectiveType } from '../types/network.types';

export const useVideoQuality = () => {
  const [videoQuality, setVideoQuality] = useState<VideoQuality>('hd');

  const detectConnectionType = () => {
    const navigatorWithConnection = navigator as NavigatorWithConnection;
    const connection = navigatorWithConnection.connection;

    if (!connection) {
      setVideoQuality('sd');
      return;
    }

    const { effectiveType } = connection.effectiveType;

    switch (effectiveType) {
      case NetworkEffectiveType.FourG:
        setVideoQuality('hd');
        break;
      case NetworkEffectiveType.ThreeG:
        setVideoQuality('sd');
        break;
      case NetworkEffectiveType.TwoG:
      case NetworkEffectiveType.Slow2G:
      default:
        setVideoQuality('sd');
        break;
    }
  };

  useEffect(() => {
    detectConnectionType();

    return () => {
    };
  }, []);

  return videoQuality;
};
